import { ArrowUpRight, ArrowDown } from "lucide-react";
import { personalInfo } from "../../data/mock";

const specs = [
  { k: "ROLE", v: "Backend Engineer" },
  { k: "FOCUS", v: "MES · ERP · Real-time" },
  { k: "STACK", v: ".NET · C# · SignalR" },
  { k: "LOCATION", v: "Gebze, Kocaeli · TR" }
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Hero = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pt-28 pb-20">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {/* Statement */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-8">
              <span className="live-dot w-2 h-2 rounded-full bg-live" />
              <span className="eyebrow">
                Available for work
                <span className="text-fg-mute"> · </span>
                Gebze / Kocaeli
                <span className="text-fg-mute"> · </span>
                UTC+3
              </span>
            </div>

            <h1 className="font-display font-bold text-fg leading-[0.95] tracking-tight text-6xl sm:text-7xl xl:text-8xl">
              <span className="block">Nurettin Fatih</span>
              <span className="block">
                AKKIN<span className="text-signal">.</span>
              </span>
            </h1>

            <p className="mt-8 max-w-xl text-2xl sm:text-3xl text-fg font-display font-medium leading-snug">
              I build the backend and real-time systems that{" "}
              <span className="text-signal">run factories</span>.
            </p>

            <p className="mt-5 max-w-xl text-base sm:text-lg text-fg-dim leading-relaxed">
              {personalInfo.description}
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollTo("projects")}
                className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-signal text-ink rounded-md font-semibold hover:bg-signal-strong transition-colors"
              >
                View work
                <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </button>
              <button
                onClick={() => scrollTo("contact")}
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-line text-fg rounded-md font-semibold hover:border-signal/60 hover:text-signal transition-colors"
              >
                Get in touch
              </button>
            </div>
          </div>

          {/* Instrument spec plate — the signature */}
          <div className="lg:col-span-5">
            <div className="relative bg-panel/70 backdrop-blur-sm border border-line rounded-lg p-6 sm:p-7 panel-ticks">
              <div className="flex items-center justify-between mb-5 pb-4 border-b border-line">
                <span className="eyebrow">
                  <span className="idx">//</span> system.spec
                </span>
                <span className="flex items-center gap-2 text-xs font-mono text-live">
                  <span className="live-dot w-1.5 h-1.5 rounded-full bg-live" />
                  ONLINE
                </span>
              </div>

              <dl className="space-y-4">
                {specs.map((s) => (
                  <div key={s.k} className="flex items-baseline gap-3 font-mono text-sm">
                    <dt className="text-fg-mute whitespace-nowrap">{s.k}</dt>
                    <span className="flex-1 border-b border-dotted border-line/80 translate-y-[-3px]" />
                    <dd className="text-fg text-right whitespace-nowrap">{s.v}</dd>
                  </div>
                ))}
              </dl>

              <div className="mt-6 pt-5 border-t border-line">
                <p className="font-mono text-xs text-fg-mute leading-relaxed">
                  <span className="text-live">$</span> now — leading backend on a
                  live MES: 100+ machines, second-by-second telemetry.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <button
        onClick={() => scrollTo("about")}
        aria-label="Scroll to about section"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-fg-mute hover:text-signal transition-colors"
      >
        <ArrowDown className="w-5 h-5 animate-bounce" />
      </button>
    </section>
  );
};

export default Hero;
